import { http } from 'lib_ui-services';
import sealInput from './sealInput';
export const _private = { http, sealInput, wait: () => new Promise(resolve => setTimeout(resolve, 2000)) };

/** Wait for this one helper request; these reads never query the reader again. */
export default async function helperRequest(url, snapshot, action, input, active) {
    if (!snapshot.publicKey) throw new Error('Connect the current Reader Connector first.');
    const id = crypto.randomUUID();
    const envelope = await _private.sealInput(snapshot.publicKey, input, id);
    if (!active()) return;
    await _private.http.post(`${url}/commands`, { id, action, envelope });
    for (let attempt = 0; attempt < 65 && active(); attempt++) {
        await _private.wait();
        if (!active()) return;
        let next;
        try {
            next = await _private.http.get(url);
        } catch (error) {
            // Retry only result reads. A temporary proxy/network error says nothing
            // about whether the helper already performed the requested operation.
            if (!error.status || [502, 503, 504].includes(error.status)) continue;
            throw error;
        }
        if (next.command?.id !== id) throw new Error('Setup request changed. Refresh before continuing.');
        if (next.command.status === 'completed') return next;
        if (next.command.status === 'failed')
            throw Object.assign(new Error(next.command.error || 'Reader Connector could not complete the request.'), {
                code: next.command.errorCode
            });
        if (next.command.status === 'expired') break;
    }
    if (active()) throw new Error('Reader Connector did not respond. Check that it is connected, then refresh.');
}
